import React from "react";

const SBS_ICON_SRC = "/icons/SBS_Favicon_Package/icon-192x192.png";

export default function SBSLogoMark({
  alt = "Selenne Business Suite",
  className,
  ...props
}) {
  return (
    <img
      {...props}
      src={SBS_ICON_SRC}
      alt={alt}
      className={className}
    />
  );
}
